export const formatDiscount = (discount) => (discount * 100).toFixed();
